module.exports = __webpack_public_path__ + "media/images/shift_top_mockups-d85a092e732466567c87d2c969715ef8.png";